import { createContext, useContext, useState, useEffect } from 'react';
import { fetchBulkOrderPageData } from './pageDataService';

const BulkOrderDataContext = createContext(null);

export const BulkOrderDataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_bulkorder_data');
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });
  
  const [isLoading, setIsLoading] = useState(!data);

  useEffect(() => {
    let isMounted = true;

    fetchBulkOrderPageData().then((result) => {
      if (isMounted && result) {
        setData(result);
        setIsLoading(false);
        try {
          localStorage.setItem('bento_bulkorder_data', JSON.stringify(result));
        } catch (e) {
          console.error("Failed to cache bulk order data", e);
        }
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <BulkOrderDataContext.Provider value={{ data, isLoading }}>
      {children}
    </BulkOrderDataContext.Provider>
  );
};

export const useBulkOrderData = () => {
  const context = useContext(BulkOrderDataContext);
  if (!context) {
    return { data: null, isLoading: true };
  }
  return context;
};
